import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "presentation-main-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InputBlock, {
      title: "Страна",
      required: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SelectMultiComponent, {
          ref: "countrySelect",
          selectId: "presentation-country",
          placeholder: "Укажите страну",
          labelOptions: "text",
          trackBy: "text",
          valueProp: "id",
          modelValue: _ctx.countryModel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.countryModel) = $event)),
          options: _ctx.countriesWithoutRussia,
          disabled: _ctx.disabled,
          required: "",
          isDirtyValidation: ""
        }, null, 8, ["modelValue", "options", "disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_InputBlock, {
      title: "Год",
      required: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SelectMultiComponent, {
          ref: "yearSelect",
          selectId: "presentation-year",
          placeholder: "Укажите год",
          labelOptions: "text",
          valueProp: "id",
          modelValue: _ctx.yearModel,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.yearModel) = $event)),
          options: _ctx.yearOptions,
          disabled: _ctx.disabled,
          required: "",
          isDirtyValidation: ""
        }, null, 8, ["modelValue", "options", "disabled"])
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_component_ButtonComponent, {
      mod: "gradient-bg",
      disabled: _ctx.disabled || _ctx.loading,
      onClick: _ctx.onSubmit
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.loading ? 'Загрузка...' : 'Скачать'), 1)
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}